<template>
  <client-only>
    <checkout-apple-pay-button v-if="isApplePayEnabled" class="w-full" @click="handleApplePay" />
  </client-only>
  <panel-variant-selection :size="{ sm: 'lg' }" />
</template>

<script lang="ts" setup>
const { allowApplePayOrderOnPDP, allowApplePayOrderOnPDPWithBopis } = useFeatureFlags()
const {
  nextAttribute,
  shippingMethod,
  triggerApplePaySession
} = usePdp()

const PanelVariantSelection = createPanel('variant-selection')

const isApplePayEnabled = computed(() =>
  allowApplePayOrderOnPDP
  && window.ApplePaySession
  && (allowApplePayOrderOnPDPWithBopis || shippingMethod.value !== 'pickup')
)

const handleApplePay = () =>
  nextAttribute.value
    ? PanelVariantSelection.open({ attribute: nextAttribute.value, enableApplePay: true })
    : triggerApplePaySession()
</script>
